import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
  useEffect,
  useRef,
} from "react";
import {
  Drawer,
  Button,
  Steps,
  Form,
  Input,
  notification,
  Space,
  Select,
  Upload,
  Tag,
  Popconfirm
} from "antd";
import { InboxOutlined, CloseOutlined, FilePdfOutlined, FileExcelOutlined, CloseCircleOutlined } from "@ant-design/icons";
import DocumentManagementAPI from "../../../../restAPI/DocumentManagement";
import ReportAPI from "../../../../restAPI/ReportAPI";
import { useSelector } from "react-redux";
import JSZip from "jszip";
import * as XLSX from "xlsx";
const Context = React.createContext({
  name: "Default",
});
const { Step } = Steps;
const { TextArea } = Input;
const onSearch = (value) => {
  console.log("search:", value);
};
const StepForm = forwardRef((props, ref) => {
  const { selectedRecords } = props;
  const { token } = useSelector(state => state.auth);
  const [form] = Form.useForm();
  const [currentStep, setCurrentStep] = useState(0);
  const [visible, setVisible] = useState(false); // Track drawer visibility
  const { Dragger } = Upload;
  const isMultipleBuyers = useRef(false); // ref for indicating Multiple Muyers are selected
  const [shareDetails, setShareDetails] = useState({}); // store share details comming from API
  const [emailInput, setEmailInput] = useState("");
  const [ccemailInput, setCCEmailInput] = useState("");
  const [bccemailInput, setBCCEmailInput] = useState("");
  const [sendButtonDisabled, setSendButtonDisabled] = useState(false);
  const [selectedrecord, setSelectedrecord] = useState([]); // set the state from recived records (Not recommended if prop can change over time)
  const [showSubmissionPopconfirm, setShowSubmissionPopconfirm] = useState(false); // show the popup confirm
  const [loading, setLoading] = useState(false);
  const fileTypeIcons = {
    pdf: <FilePdfOutlined className="file-icon pdf" />,
    xls: <FileExcelOutlined className="file-icon excel" />,
    xlsx: <FileExcelOutlined className="file-icon excel" />,
    zip: <InboxOutlined className="file-icon zip" />,
  };

  //remove emails from tag
  const removeEmail = (email) => {
    setEmailInput(emailInput.filter((item) => item !== email));
    form.setFieldsValue({ to: "" });
    //if(emailinputRef.current) emailinputRef.current.input.value = '';
  };
  const removeFromArrayState = (setArrayFn, predicate) => {
    setArrayFn(prevArray => prevArray.filter(item => !predicate(item)));
    form.setFieldsValue({ cc: '' });
    form.setFieldsValue({ bcc: '' });

  };

  const onFinishFailed = (errorInfo) => {
    console.log('Validation Failed:', errorInfo);
  };

  useEffect(() => {
    setSelectedrecord(selectedRecords);
  }, [selectedRecords]); // Only run this effect when initialName changes

  useEffect(() => {
    //load the initial details from the API
    if (Object.keys(selectedrecord).length > 0) {
      // check if selected invoices have multiple Buyers
      //This goes through each item in data and picks the group value. A Set is a built-in JavaScript object that stores only unique values,
      // The ... spread operator converts the Set back into a regular array:
      let disnictBuyers = [...new Set(selectedrecord.map(item => item.buyerName))];
      isMultipleBuyers.current = disnictBuyers.length > 1 ? true : false;
      GetInvoiceSharingDetails();
    }
  }, [selectedrecord]);

  const handleSend = async () => {
    try {
      setLoading(true);
      setShowSubmissionPopconfirm(false); // incase this is called through the confirmpopup
      setSendButtonDisabled(true);
      const extractedToEmails = emailInput;//await handleExtractEmails(emailInput);
      const extractedccEmails = ccemailInput; //await handleExtractEmails(ccemailInput);
      const extractedbccEmails = bccemailInput;//await handleExtractEmails(bccemailInput);

      const formData = form.getFieldsValue();
      formData.to = extractedToEmails;
      formData.cc = extractedccEmails;
      formData.bcc = extractedbccEmails;

      if (formData.to.length === 0 || !formData.subject || !formData.body) {
        api.error({
          message: "Validation Error",
          description: "Please fill in all required fields.",
          placement: "bottomLeft",
        });
        return;
      }

      const accessToken = token;
      const groupId = localStorage.getItem("groupId");
      const companyId = localStorage.getItem("companyId");

      const downloadPromises = selectedRecords.map(async (record) => {
        try {
          const formData = new FormData();
          formData.append("groupId", groupId);
          formData.append("companyId", companyId);
          formData.append("MOGU_UUID", record.documentMoguID);
          formData.append("TPS_Id", record.tPS_Id);

          const response = await DocumentManagementAPI.downloadDocumentWithQRCodeZip(accessToken, formData);
          const blob = new Blob([response.data], { type: "application/pdf" });
          const safeFileName = (record.invoiceNumber || "Document").replace(/[\/\\?%*:|"<>]/g, "-");
          return { success: true, fileName: `${safeFileName}.pdf`, blob };
        } catch (err) {
          console.error(`Failed to download ${record.invoiceNumber}`, err);
          return { success: false, invoiceNumber: record.invoiceNumber };
        }
      });

      const results = await Promise.all(downloadPromises);

      const zip = new JSZip();
      const failedDownloads = [];

      results.forEach(result => {
        if (result.success) {
          zip.file(result.fileName, result.blob);
        } else {
          failedDownloads.push(result.invoiceNumber);
        }
      });

      if (failedDownloads.length > 0) {
        openNotificationWithIcon(
          "warning",
          "Partial Success",
          `Failed to download: ${failedDownloads.join(", ")}`,
          "bottomLeft"
        );
      }
      // Check if zip has any files
      if (Object.keys(zip.files).length === 0) {
        api.error({
          message: "Error",
          description: "No documents to attach.",
          placement: "bottomLeft",
        });
        setSendButtonDisabled(false);
        return;
      }

      const zipBlob = await zip.generateAsync({ type: "blob" });

      const file = new File([zipBlob], "documents.zip", { type: "application/zip" });

      const newFormData = new FormData();

      newFormData.append("bcc", extractedbccEmails);
      newFormData.append("cc", extractedccEmails);
      newFormData.append("body", formData.body);
      newFormData.append("subject", formData.subject);
      
      // Check if PDF attachment is still in the attachments list before including it
      const shouldIncludePdf = attachments.some(attachment => attachment.type === "pdf");
      if (shouldIncludePdf) {
        newFormData.append("attachments", file);
      }
      
      // Check if Excel attachment is still in the attachments list before including it
      const shouldIncludeExcel = attachments.some(attachment => attachment.type === "excel");
      if (shouldIncludeExcel) {
        // Generate Excel file and add it to attachments
        const excelBlob = await getExcelfileAsBlob();
        const excelFile = new File([excelBlob], "SelectedRecords.xlsx", { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        newFormData.append("attachments", excelFile);
      }
      
      newFormData.append("to", extractedToEmails);
      await DocumentManagementAPI.FileShareEmail(accessToken, newFormData).then((response) => {
        openNotificationWithIcon(
          "success",
          "Successful",
          `Email sent successfully!`,
          "bottomLeft"
        );
      })
        .catch((err) => {
          if (err.response) {
            openNotificationWithIcon(
              "error",
              "Failed",
              "Email sending failed",
              "bottomLeft"
            );
          } else {
            openNotificationWithIcon(
              "error",
              "Failed",
              "Email sending failed",
              "bottomLeft"
            );
          }
        })
        .finally(() => {
          setLoading(false); // stop loading
        });


      // openNotification("bottomLeft", "Email sent successfully!");
      closeDrawer();
      setSendButtonDisabled(false);
    } catch (error) {
      console.error("Error sending email:", error);
      api.error({
        message: "Error",
        description: "Failed to send email. Please try again.",
        placement: "bottomLeft",
      });
      setSendButtonDisabled(false);
    }
  };

  const getExcelfileAsBlob = async () => {
    const headings = [
      [
        "Key",
        "Document Mogu ID",
        "Uploaded User ID",
        "Invoice Number",
        "Document Type",
        "Classification",
        "Upload Date",
        "Uploaded By",
        "Supplier Name",
        "Buyer Name",
        "Status",
        "Original File Path",
        "Is Active",
        "Is Duplicate",
        "Is Tax Mismatch",
        "TPS ID",
        "Total Tax Amount",
        "Total Payble Amount",
        "URL",
        "Validated Date And Time",
        "UUID"
      ],
    ];

    try {
      const rows = Array.isArray(selectedRecords) ? selectedRecords : [];
      const data = rows.map((rowValue) => [
        rowValue.key || "",
        rowValue.documentMoguID || "",
        rowValue.uploadedUserId || "",
        rowValue.invoiceNumber || "N/A",
        rowValue.documentType || "N/A",
        rowValue.classification || "N/A",
        rowValue.uploadDate || "N/A",
        rowValue.uploadedBy || "N/A",
        rowValue.supplierName || "N/A",
        rowValue.buyerName || "N/A",
        rowValue.status || "N/A",
        rowValue.originalFilePath || "N/A",
        rowValue.isActive || "",
        rowValue.isDuplicate || "",
        rowValue.isTaxMismatch || "",
        rowValue.tPS_Id || "",
        rowValue.totalTaxAmount || "0",
        rowValue.totalPayableAmount || "",
        rowValue.url || "",
        rowValue.InvoiceDateTime || "",
        rowValue.uuid || ""
      ]);

      const worksheetData = [...headings, ...data];
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Records");

      // Generate binary string and convert to Blob
      const binaryString = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
      const buffer = new ArrayBuffer(binaryString.length);
      const view = new Uint8Array(buffer);

      for (let i = 0; i < binaryString.length; i++) {
        view[i] = binaryString.charCodeAt(i) & 0xff;
      }

      return new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    } catch (error) {
      console.error("Error generating Excel file:", error);
      throw error;
    }
  };

  const handleUpload = ({ file }) => {
    setAttachments((prev) => [...prev, file]);
  };

  const [attachments, setAttachments] = useState([
    { name: "example.pdf", type: "pdf" },
    { name: "report.xlsx", type: "excel" },
  ]);

  const removeAttachment = (fileName) => {
    const updatedAttachments = attachments.filter((file) => file.name !== fileName);
    // Prevent removing all attachments - at least one must remain
    if (updatedAttachments.length > 0) {
      setAttachments(updatedAttachments);
    } else {
      // Show error message if trying to remove the last attachment
      api.error({
        message: "Cannot remove attachment",
        description: "At least one attachment must remain.",
        placement: "bottomLeft",
      });
    }
  };



  const closeDrawer = () => {
    setVisible(false);
    setEmailInput("");
    setCCEmailInput("");
    setBCCEmailInput("");
    form.setFieldsValue({ subject: '' });
    form.setFieldsValue({ body: '' });
    // Reset attachments to include both PDF and Excel options
    setAttachments([
      { name: "example.pdf", type: "pdf" },
      { name: "report.xlsx", type: "excel" },
    ]);
  };

  // Expose methods to the parent component
  useImperativeHandle(ref, () => ({
    openDrawer: () => {
      setVisible(true); // Open drawer
      // Reset attachments to include both PDF and Excel options when opening
      setAttachments([
        { name: "example.pdf", type: "pdf" },
        { name: "report.xlsx", type: "excel" },
      ]);
    },
    closeDrawer: () => {
      setVisible(false); // Close drawer
    },
  }));
  const [api, contextHolder] = notification.useNotification();
  const { Option } = Select;
  const openNotification = (placement) => {
    api.success({
      message: `Success`,
      description: (
        <Context.Consumer>
          {({ name }) => `Email Sent Successfully`}
        </Context.Consumer>
      ),
      placement,
    });
  };
  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement
    });
  };

  const contextValue = useMemo(
    () => ({
      name: "Ant Design",
    }),
    []
  );

  //Handle Email List adding event
  const addEmail = async (value, property) => {
    let extractedMailList = [];
    if (property === "to") {
      //EmailList
      extractedMailList = await handleExtractEmails(value);
      let updated = [...emailInput, ...extractedMailList];
      const uniqueEmails = Array.from(new Set(updated));
      setEmailInput(uniqueEmails);
      form.setFieldsValue({ to: '' });
    }
    else if (property === "cc") {
      extractedMailList = await handleExtractEmails(value);
      let updated = [...ccemailInput, ...extractedMailList];
      const uniqueEmails = Array.from(new Set(updated));
      setCCEmailInput(uniqueEmails);
      form.setFieldsValue({ cc: '' });
    }
    else {
      extractedMailList = await handleExtractEmails(value);
      let updated = [...bccemailInput, ...extractedMailList];
      const uniqueEmails = Array.from(new Set(updated));
      setBCCEmailInput(uniqueEmails);
      form.setFieldsValue({ bcc: '' });
    }
  }

  const validateEmail = (email) => {
    //const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const regex = /^([a-zA-Z0-9]|\.|-)+@([a-zA-Z0-9]|\.|-)+\.[a-zA-Z]+$/gm;
    return regex.test(email);
  };

  const handleExtractEmails = async (emailset) => {
    const raw = emailset
      .replace(/[\n\r]/g, "")
      .split(/[,;]+/)
      .map(email => email.trim().toLowerCase())
      .filter(email => validateEmail(email));

    const uniqueEmails = Array.from(new Set(raw));
    return uniqueEmails
  };

  const next = () => setCurrentStep(currentStep + 1);
  const prev = () => setCurrentStep(currentStep - 1);

  const onClose = () => setVisible(false);
  //-------------------------------------------------------------------PopUp Confirm Methode----------------------------------------------------------------
  const handleAbortSubmissionConfirm = () => {
    //submissionCancelButtonDisabled(true);
    setTimeout(() => {
      setShowSubmissionPopconfirm(false);
      // submissionCancelButtonDisabled(false);
    }, 3000);
  };

  const onSubmissionPopConfirm = () => {
    if (isMultipleBuyers.current) {
      setShowSubmissionPopconfirm(true); // Show the confirmation popup
    }
    else {
      form.submit();  // Directly submit if no need to confirm
    }
  }
  //--------------------------------------------------------------------End of Popup Confirm-----------------------------------------------------------------

  //-----------------------------------------------------------------------API Calls-------------------------------------------------------------------------------------
  const GetInvoiceSharingDetails = async () => {
    //Generate request shareList
    const shareList = [];
    selectedrecord.map((record) => {
      const shareListItem = {
        TPS_Id: record.tPS_Id,
        MOGU_UUID: record.documentMoguID
      };
      shareList.push(shareListItem);
    });

    const payload = {
      companyId: localStorage.getItem('companyId'),
      shareList: shareList
    }
    await ReportAPI.GetInvoiceSharingDetails(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'), payload)
      .then((res) => {
        if (res?.data) {
          const documetShareDetails = {
            emailList: res.data.buyers,
            pdfFiles: res.data.pdfFiles,
            excelFiles: res.data.excelFiles
          };
          setShareDetails(documetShareDetails);
          setEmailInput(documetShareDetails.emailList);
        }
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon('error', 'No Share Details found', `${err.response.data.message}`, 'bottomLeft');
        } else {
          openNotificationWithIcon('error', 'No Share Details  found', `${err.message}`, 'bottomLeft');
        }
      });
  }
  //------------------------------------------------------------------------End of API------------------------------------------------------------------------------------

  return (
    <Context.Provider value={contextValue}>
      {contextHolder}
      <Drawer
        title="Share Document"
        width={700}
        visible={visible}
        onClose={closeDrawer}
        footer={
          <div style={{ textAlign: "right" }}>
            <Button style={{ marginRight: 8 }} size="large" onClick={closeDrawer}>
              Cancel
            </Button>

            <Popconfirm
              title={`The selected documents belong to multiple Buyers. Do you want to proceed with sharing them?`}
              open={showSubmissionPopconfirm}
              onConfirm={() => { form.submit(); }}
              onCancel={handleAbortSubmissionConfirm}
              okText="Confirm"
              cancelText="Cancel"
            >
              <Button
                disabled={loading}
                type="primary"
                size="large"
                onClick={!loading ? onSubmissionPopConfirm : null}
              >
                {loading ? "Sending..." : "Send"}
              </Button>
            </Popconfirm>
          </div>
        }
      >
        <div style={{ marginTop: 24 }}>
          <Tag bordered={false} color="geekblue" style={{ fontSize: '14px' }}>Copy Multiple emails seperated by ' ; ' / Single email adresses and press Enter</Tag>
          <Form layout="vertical" form={form}
            onFinish={handleSend}
            onFinishFailed={onFinishFailed}>
            {/* TO Field */}
            <Space wrap>
              {emailInput.length > 0 && emailInput.map((email) => (
                <Tag
                  color="orange"
                  key={email}
                  closable
                  onClose={() => removeEmail(email)}
                  closeIcon={<CloseOutlined />}
                  style={{ marginBottom: '5px', marginTop: '5px' }}
                >
                  {email}
                </Tag>
              ))}
              {emailInput.length > 0 && (
                <Button 
                  type="link" 
                  size="small" 
                  onClick={() => setEmailInput([])}
                  style={{ padding: '0 4px', height: 'auto', fontSize: '12px' }}
                >
                  Clear All
                </Button>
              )}
            </Space>
            <Form.Item label="TO" name="to" required
              rules={[
                {
                  validator: (_, value) =>
                    emailInput.length > 0
                      ? Promise.resolve()
                      : Promise.reject(new Error('Please add at least one email')),
                },
              ]}>
              <Input
                placeholder="Add email"
                size="large"
                onPressEnter={(e) => {
                  e.preventDefault(); //prevent form submission on Enter
                  addEmail(e.target.value, "to");
                }}
              />
            </Form.Item>

            {/* CC Field */}
            <Space wrap>
              {ccemailInput.length > 0 && ccemailInput.map((email) => (
                <Tag
                  color="purple"
                  key={email}
                  closable
                  onClose={() => removeFromArrayState(setCCEmailInput, item => item === email)}
                  closeIcon={<CloseOutlined />}
                  style={{ marginBottom: '5px', marginTop: '5px' }}
                >
                  {email}
                </Tag>
              ))}
              {ccemailInput.length > 0 && (
                <Button 
                  type="link" 
                  size="small" 
                  onClick={() => setCCEmailInput([])}
                  style={{ padding: '0 4px', height: 'auto', fontSize: '12px' }}
                >
                  Clear All
                </Button>
              )}
            </Space>
            <Form.Item label="CC" name="cc">
              <Input
                placeholder="Add CC emails"
                size="large"
                onPressEnter={(e) => {
                  e.preventDefault(); //prevent form submission on Enter
                  addEmail(e.target.value, "cc");
                }} />
            </Form.Item>

            {/* BCC Field */}
            <Space wrap>
              {bccemailInput.length > 0 && bccemailInput.map((email) => (
                <Tag
                  color="magenta"
                  key={email}
                  closable
                  onClose={() => removeFromArrayState(setBCCEmailInput, item => item === email)}
                  closeIcon={<CloseOutlined />}
                  style={{ marginBottom: '5px', marginTop: '5px' }}
                >
                  {email}
                </Tag>
              ))}
              {bccemailInput.length > 0 && (
                <Button 
                  type="link" 
                  size="small" 
                  onClick={() => setBCCEmailInput([])}
                  style={{ padding: '0 4px', height: 'auto', fontSize: '12px' }}
                >
                  Clear All
                </Button>
              )}
            </Space>
            <Form.Item label="BCC" name="bcc">
              <Input
                placeholder="Add BCC emails"
                size="large"
                onPressEnter={(e) => {
                  e.preventDefault(); //prevent form submission on Enter
                  addEmail(e.target.value, "bcc");
                }} />
            </Form.Item>

            {/* Subject Field */}
            <Form.Item label="Subject" name="subject"
              rules={[{ required: true, message: "Email subject is required" }]} required>
              <Input size="large" placeholder="Enter subject" />
            </Form.Item>

            {/* Body Field */}
            <Form.Item label="Body" name="body"
              rules={[{ required: true, message: "Email body is required" }]} required>
              <Input.TextArea placeholder="Enter your message" rows={4} />
            </Form.Item>


            {/* Attachments */}
            <Form.Item label="Attachments">
              <div className="attachments-container">
                {/* PDF attachment (can be removed) */}
                {attachments.some(attachment => attachment.type === "pdf") && (
                  <div className="attachment-item">
                    <FilePdfOutlined className="file-icon pdf" />
                    <div className="file-name">PDF</div>
                    <CloseCircleOutlined
                      className="remove-icon"
                      onClick={() => removeAttachment("example.pdf")}
                    />
                  </div>
                )}
                
                {/* Excel attachment (can be removed) */}
                {attachments.some(attachment => attachment.type === "excel") && (
                  <div className="attachment-item">
                    <FileExcelOutlined className="file-icon excel" />
                    <div className="file-name">EXCEL</div>
                    <CloseCircleOutlined
                      className="remove-icon"
                      onClick={() => removeAttachment("report.xlsx")}
                    />
                  </div>
                )}
              </div>
            </Form.Item>
          </Form>

        </div>
      </Drawer>
    </Context.Provider>
  );
});

export default StepForm;
